import React from "react";
import { Lock } from "lucide-react";

const EnrolHeaderCard = ({ isStudent = false }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-3xl p-6 sm:p-8 flex flex-col items-center text-center space-y-4 shadow-xs">
      <div className="inline-flex items-center gap-1.5 px-3.5 py-1 rounded-full bg-[#E0F2FE] border border-[#BAE6FD] text-[#0369a1] text-xs font-bold">
        <span className="animate-pulse">✨</span> Practido AI LAB Program
      </div>

      <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-950 tracking-tight leading-tight">
        {isStudent ? "Enrol in a Live Online Course" : "Enrol Your Child in a Live Online Course"}
      </h2>

      <p className="text-xs sm:text-sm text-gray-400 font-semibold max-w-2xl leading-relaxed">
        {isStudent
          ? "Select your course, complete payment, and we'll confirm your first class within 24 hours - directly on WhatsApp."
          : "Select your course, complete payment, and we'll confirm your child's first class within 24 hours - directly on WhatsApp."}
      </p>

      {/* Horizontal highlight row */}
      <div className="w-full bg-[#F5FAFE]/80 border border-[#E0F0FC] rounded-2xl p-4 flex flex-col sm:flex-row items-center justify-around gap-4">
        <div className="flex items-center gap-2">
          <div className="p-2 bg-white rounded-xl border border-gray-150 shadow-3xs text-blue-500 flex items-center justify-center">
            <Lock className="w-4 h-4" />
          </div>
          <span className="text-xs font-bold text-gray-600">100% Secure via Razorpay</span>
        </div>

        <div className="flex items-center gap-2">
          <div className="p-2 bg-white rounded-xl border border-gray-150 shadow-3xs text-emerald-500 flex items-center justify-center">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <span className="text-xs font-bold text-gray-600">Instant WhatsApp update</span>
        </div>

        <div className="flex items-center gap-2">
          <div className="p-2 bg-white rounded-xl border border-gray-150 shadow-3xs text-purple-500 flex items-center justify-center">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l9-5-9-5-9 5 9 5z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
            </svg>
          </div>
          <span className="text-xs font-bold text-gray-600">Classes 1 to 12 supported</span>
        </div>
      </div>
    </div>
  );
};

export default EnrolHeaderCard;
